// shows popup to redirect if user is in "wrong" region
import Cookies from 'js-cookie/src/js.cookie';

const actionCountry = ():void => {
  
  const euLocalesElem = document.querySelector('[data-eu-locales]') as HTMLElement
  const gbLocalesElem = document.querySelector('[data-gb-locales]') as HTMLElement
  const redirectBtn = document.querySelector('[data-locale-target]') as HTMLElement

  if(!euLocalesElem || !gbLocalesElem || !redirectBtn) return

  const euLocales = euLocalesElem.dataset.euLocales.split(',')
  const gbLocales = gbLocalesElem.dataset.gbLocales.split(',')

  const closers = document.querySelectorAll('[data-geo-popup-close]')
  closers.forEach(el => {
    el.addEventListener('click', ()=> {
      Cookies.set('geoPopupDismissed', 'true', { expires: 3 })
      document.body.classList.remove('currency-selector-modal-open', 'modal-visible')
    })
  });

  const locale = window['blubolt'].geo.handle
  const currentCurrency = window['Shopify'].currency.active

  redirectBtn.addEventListener('click', e => {
    const form = document.querySelector('#currency_form') as HTMLFormElement
    const select = document.querySelector('#currency_form select') as HTMLSelectElement
    const btn = e.target as HTMLElement
    select.selectedIndex = parseInt(btn.dataset.localeTarget)
    form.submit()
  })
  
  if (Cookies.get('geoPopupDismissed') === 'true') { return }

  if(euLocales.includes(locale) && currentCurrency === 'GBP') {
    document.body.classList.add('currency-selector-modal-open', 'modal-visible')
  }

  if(gbLocales.includes(locale) && currentCurrency === 'EUR') {
    document.body.classList.add('currency-selector-modal-open', 'modal-visible')
  }
}

export default actionCountry